import { AuthClient } from '@/api/auth-client'
import { SmartMarketingSelection } from '@/api/types'

export const SmartMarketingAPI = new class SmartMarketingClient extends AuthClient {

    async getContactsCount(selection: SmartMarketingSelection) {
        const response = await this.client.post(`/api/v1/service/smart_marketing/count`, {
            company: selection.company.resourceIdentifier,
            includeInternalContacts: selection.includeInternalContacts,
            includeExternalContacts: selection.includeExternalContacts,
            includeRealworksRelaties: selection.includeRealworksRelaties,
            syncedRealworksKenmerken: selection.syncedRealworksKenmerken,
            excludedRealworksKenmerken: selection.excludedRealworksKenmerken,
            syncedRealworksRelatietypes: selection.syncedRealworksRelatietypes,
            syncedRealworksStatus: selection.syncedRealworksStatus,
            updatedFrom: selection.updatedFrom ? selection.updatedFrom : null,
            updatedUntil: selection.updatedUntil ? selection.updatedUntil : null,
        }, {
            headers: {
                Accept: 'application/json',
            },
        })

        return response.data.count
    }

}()
